<template>
  <div class="form">
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
      label-position="left"
      :rules="rules"
    >
      <el-form-item label="OA账号" prop="account" required>
        <el-input
          v-model="form.account"
          size="mini"
          style="width: 150px"
        ></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name" required>
        <el-input
          v-model="form.name"
          size="mini"
          style="width: 150px"
        ></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type" required>
        <el-radio-group v-model="form.type" size="mini" class="user-type">
          <el-radio :label="301">管理员</el-radio>
          <el-radio :label="302">普通账户</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="手机">
        <el-input
          v-model="form.mobile"
          size="mini"
          style="width: 150px"
        ></el-input>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input
          v-model="form.email"
          size="mini"
          style="width: 290px"
        ></el-input>
      </el-form-item>
      <el-form-item class="edit-buttons">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="$emit('close')" plain>取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'EditUser',
  data() {
    return {
      form: {},
      id: '',
      rules: {
        account: [{ required: true, message: '请输入OA账号' }],
        name: [{ required: true, message: '请输入姓名' }],
        type: [{ required: true, message: '请选择用户类型' }],
      }
    };
  },
  methods: {
    initForm(id) {
      this.$refs.form.resetFields();
      this.form = {};
      this.id = id;
      if (id && id !== 'create') {
        this.$store
          .dispatch('account/fetchOne', {
            id: +id
          })
          .then(res => {
            this.form = res;
          });
      }
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.id && this.id !== 'create') {
            this.$store
              .dispatch('account/update', {
                id: +this.id,
                ...this.form
              })
              .then(() => {
                this.$emit('close');
              });
          } else {
            this.$store
              .dispatch('account/create', {
                ...this.form
              })
              .then(() => {
                this.$emit('close');
              });
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.form {
  background: #fff;
  .el-form-item {
    padding: 14px 0 14px 24px;
    margin: 0;
    border-bottom: 1px solid #e9edf0;
    &:last-child {
      border-bottom: none;
    }
    .user-type {
      width: 100%;
      display: flex;
      align-items: center;
      height: 40px;
      .el-radio {
        margin-right: 24px;
      }
    }

    &.edit-buttons {
      display: flex;
      margin-right: 24px;
      justify-content: flex-end;
    }
  }
}
</style>
